import { match } from '@frontend/duck-tape';
import { Button, Icon, Text, XStack, YStack } from '@frontend/web-react';
import { PaywallFlow } from '../PaywallFlow';
import { usePaywallPricingContext } from '../PaywallPricingContext';
import { SkeletonPlanCard } from '../SkeletonPlanCard';

export const PaywallModalBody = ({ onClose }: { onClose: () => void }) => {
  const { isError, isLoading, refetch } = usePaywallPricingContext();

  return match({ isError, isLoading })
    .with({ isLoading: true }, () => (
      <YStack accessibilityLabel="Paywall loading" gap="md" p="md">
        <Text type="h4">Loading your plans…</Text>
        <YStack gap="md" width="100%">
          <SkeletonPlanCard />
          <SkeletonPlanCard />
          <SkeletonPlanCard />
        </YStack>
      </YStack>
    ))
    .with({ isError: true }, () => (
      <YStack accessibilityLabel="Paywall error" gap="md" p="md">
        <XStack alignItems="center" gap="sm">
          <Icon className="text-red-500" name="IconAlertCircle" size={24} />
          <Text type="h4">Your plans took a duck dive.</Text>
        </XStack>
        <Text color="secondary" type="p-sm">
          {"Don't worry, we'll bring them back. Try again."}
        </Text>
        <XStack gap="md">
          <Button label="Close" onClick={onClose} size="md" variant="secondary" />
          <Button label="Try again" onClick={() => refetch()} size="md" variant="primary" />
        </XStack>
      </YStack>
    ))
    .otherwise(() => <PaywallFlow />);
};
